/**
 * Human-facing label for IntentML / registry artifact type refs.
 * Prefer PascalCase identity; convert pt-* slugs for display only (raw ref stays available for logic).
 */
const PT_SLUG_RE = /^pt-[a-z0-9-]+$/i;

export function ptSlugToPascalCase(slug: string): string {
  const body = slug.trim().replace(/^pt-/i, '');
  return body
    .split('-')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join('');
}

/** Display label for subtitles and lists; never invent a type when ref is empty. */
export function formatArtifactTypeRefDisplay(artifactTypeRef: string | null | undefined): string {
  const raw = (artifactTypeRef ?? '').trim();
  if (!raw) return '';
  if (PT_SLUG_RE.test(raw)) {
    return ptSlugToPascalCase(raw);
  }
  return raw;
}
